export default "__VITE_ASSET__CyT0JpXe__"